export const childAbuseItHTML = (logo) => {
  return (`
  <!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Votiamo App - Informativa sulla Privacy</title>
  <style>
      body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
          color: #333;
      }
      header {
          text-align: center;
          padding: 20px 0;
          background-color: #fff;
      }
      header img {
          width: 150px;
          height: auto;
      }
      header h1 {
          margin: 10px 0 0;
          font-size: 24px;
          color: #0073a6;
      }
      main {
          padding: 20px;
          max-width: 90%;
          margin: 20px auto;
      }
      h2 {
          color: #005580;
          margin-top: 20px;
      }
      h3 {
          color: #333;
          margin-top: 15px;
      }
      p {
          margin: 10px 0;
      }
      ul {
          margin: 10px 0 20px;
          padding-left: 20px;
      }
      footer {
          text-align: center;
          padding: 10px 0;
          font-size: 12px;
          color: #777;
      }
      .highlight {
          font-weight: bold;
          color: #0073a6;
      }
  </style>
</head>
<body>
  <header>
      <img src="${logo}" alt="Logo Votiamo App">
      <h1>Votiamo App - Informativa sulla Privacy</h1>
  </header>
  <main>
      <section>
    <h2>Standard per l'Abuso e lo Sfruttamento Sessuale dei Minori (CSAE)</h2>
    <p>In Votiamo, ci impegniamo a fornire un ambiente sicuro e rispettoso per tutti gli utenti, in particolare per i minori. Adottiamo un approccio di tolleranza zero verso l'abuso e lo sfruttamento sessuale dei minori (CSAE) e abbiamo implementato rigide politiche interne per prevenire e rispondere a tali incidenti.</p>
    
    <p>I nostri sforzi di protezione CSAE includono:</p>

    <ul>
        <li><strong>Monitoraggio dei Contenuti:</strong> Monitoriamo i contenuti generati dagli utenti (se applicabile) per identificare e bloccare qualsiasi materiale che possa essere correlato al CSAE o ad altri comportamenti dannosi.</li>
        <li><strong>Strumenti di Segnalazione:</strong> Forniamo modalità chiare e semplici per gli utenti per segnalare contenuti o comportamenti inappropriati direttamente all'interno dell'app.</li>
        <li><strong>Cooperazione con le Forze dell'Ordine:</strong> Collaboriamo pienamente con le forze dell'ordine e le autorità competenti in caso di attività CSAE segnalate o sospette.</li>
        <li><strong>Sensibilizzazione Educativa:</strong> Miriamo a educare i nostri utenti, in particolare genitori e tutori, sulla sicurezza online e su come riconoscere potenziali rischi legati al CSAE.</li>
        <li><strong>Revisioni Interne Regolari:</strong> Effettuiamo revisioni interne della sicurezza per garantire che le nostre misure protettive rimangano efficaci e aggiornate.</li>
    </ul>

    <p>Sebbene non abbiamo ancora pubblicato standard CSAE formali esternamente, stiamo lavorando attivamente per rendere pubbliche le nostre politiche e procedure interne per una completa trasparenza.</p>

    <p>Se ritieni di aver incontrato contenuti o comportamenti inappropriati relativi al CSAE, ti preghiamo di contattarci immediatamente all'indirizzo <a href="mailto:support@votiamo.com">support@votiamo.com</a>.</p>
</section>
  </main>

 
  <footer>
      <p>&copy; 2025 Il Cavedio Società Cooperativa. Tutti i diritti riservati.</p>
  </footer>
</body>
</html>
  `)
};
